import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "/",
      name: "Main",
      meta: { title: "Devices" },
      component: () =>
        import(/* webpackChunkName: "main" */ "../views/Main.vue")
    },
    {
      path: "/main",
      redirect: "/"
    },
    {
      path: "/login",
      name: "Login",
      meta: { title: "Login" },
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
      path: "/groups-users",
      name: "GroupsUsers",
      meta: { title: "Groups & Users" },
      component: () =>
        import(/* webpackChunkName: "groups-users" */ "../views/GroupsUsers.vue")
    },
    {
      path: "/events",
      name: "Events",
      meta: { title: "Connection Events" },
      component: () =>
        import(/* webpackChunkName: "events" */ "../views/Events.vue")
    },
    {
      path: "/groups",
      redirect: "/groups-users"
    },
    {
      path: "/users",
      redirect: "/groups-users"
    }
  ]
});
